export const MAX_RPM = 10000;
export const MAX_SPEED = 330;
export const MAX_OIL_TEMPERATURE = 120;
export const MAX_ACCELERATION = 0.76;
export const MAX_HANDLING = 3.29;
